/** JSON Viewer Types */

/** Supported JSON node types */
export type JsonNodeType = 'object' | 'array' | 'string' | 'number' | 'boolean' | 'null' | 'json-string';

/** Represents a node in the JSON tree */
export interface JsonViewerNode {
  /** Property key or array index */
  key: string;
  /** Original value */
  value: unknown;
  /** Type of the value */
  type: JsonNodeType;
  /** Whether the node is collapsed */
  collapsed: boolean;
  /** Child nodes (for objects, arrays, json-strings) */
  children?: JsonViewerNode[];
  /** Parsed JSON (for json-string type) */
  parsedJson?: unknown;
}

/** View mode for the JSON viewer */
export type JsonViewerMode = 'tree' | 'raw' | 'edit';

/** Configuration for the JSON viewer */
export interface JsonViewerConfig {
  /** Default collapsed state for objects/arrays */
  defaultCollapsed?: boolean;
  /** Indentation per level in pixels */
  indentSize?: number;
  /** Keys that should have their string values parsed as JSON */
  jsonStringKeys?: string[];
  /** Maximum depth to auto-expand (-1 for unlimited) */
  maxAutoExpandDepth?: number;
  /** Show line numbers */
  showLineNumbers?: boolean;
  /** Enable syntax highlighting */
  syntaxHighlighting?: boolean;
  /** Show built-in toolbar with Expand All, Collapse All, Copy, and Raw/Tree toggle */
  showToolbar?: boolean;
  /** Enable editor mode - adds an Edit view mode with textarea for editing JSON */
  editable?: boolean;
  /** Show footer with line/character counts (shown in edit mode) */
  showFooter?: boolean;
  /** Initial view mode */
  initialViewMode?: JsonViewerMode;
}

/** Default configuration */
export const DEFAULT_JSON_VIEWER_CONFIG: JsonViewerConfig = {
  defaultCollapsed: false,
  indentSize: 16,
  jsonStringKeys: ['valueString'],
  maxAutoExpandDepth: -1,
  showLineNumbers: false,
  syntaxHighlighting: true,
  showToolbar: false,
  editable: false,
  showFooter: false,
  initialViewMode: 'tree',
};
